import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { getTypeColor, getReadStatusColor } from "../../../../constants/colors";

/**
 * アイコン + テキスト の1行表示
 */
const IndexCardInfoRow = ({ type, isNew, icon: Icon, text }) => {
  const theme = useTheme();

  // job/project 用の共通設定
  const color = getTypeColor(type);

  // 未読＝黒、既読＝薄いグレー
  const textColor = getReadStatusColor(theme, isNew);

  if (!text) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
      <Icon sx={{ fontSize: { xs: 14, sm: 18 }, color }} />
      <Typography
        sx={{
          fontSize: { xs: "0.7rem", sm: "0.75rem" },
          color: textColor,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default IndexCardInfoRow;
